import { types } from "../types/types"
import { crearErrorAction,crearErrorTotOkAction,crearTotOkAction, uiAmagarJornadaCompletaAction, uiJornadaCompletaRealitzadaAction } from "./ui"
import { convertirHoresaSegons } from "../Helpers/funcionsDates"





export const recuperarIncidenciesDiaConsultat = (token,data) =>{
    //Aquesta funció (Middleware), retorna un callback. Just quan finalitza la petició, execitarà l'acció 
    return (dispatch) =>{   
        var dadesFormulari = {
            'dataConsulta': data
        };
        
        var formBody = [];
            for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8','Accept':'application/json','Authorization' : token },
                credentials: 'include',
                body: formBody
            };        
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/incidencia/dia/list',requestOptions)

        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
           
            if (response.status != 200) {
                // get error message from body or default to response status
                //const error = (data && data.message) || response.status;
                dispatch(crearErrorAction("Error del servei d'autenticació: " +  JSON.stringify(data)));
            }else
            {            
                //Fem el dispatch de l'acció login amb les dades rebudes del servei
                if(data.dia !=undefined)
                {
                    let { dia,incidencies } = data;
                    dispatch(IncidenciaDiaConsultat(data));
                }else
                {
                    //El servei d'aunteticació reporta un error de login
                    
                }  
            }
            //element.innerHTML = data.id;
        })
        .catch(error => {
           // element.parentElement.innerHTML = `Error: ${error}`;
            dispatch(crearErrorAction("Excepció no controlada -  " + JSON.stringify(error)));
            console.error('There was an error!', error);
        });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
       
        /*setTimeout(() => {
                //Als 3 segons, farem un dispatch del l'acció Login. 
                
                dispatch(login(123,345,"German, usuari autenticat"));

            }, 3500);*/
    }


} 
export const recuperarFixatgesDiaConsultat = (token,data) =>{
    //Aquesta funció (Middleware), retorna un callback. Just quan finalitza la petició, execitarà l'acció 
    return (dispatch) =>{   
        var dadesFormulari = {
            'dataConsulta': data
        };
        var formBody = [];
            for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8','Accept':'application/json','Authorization' : token },
                credentials: 'include',
                body: formBody
            };
            
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/fixatge/dia/list',requestOptions)

        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
           
            if (response.status != 200) {
                // get error message from body or default to response status
                //const error = (data && data.message) || response.status;
                dispatch(crearErrorAction("Error del servei d'autenticació: " +  JSON.stringify(data)));
            }else
            {             
                //Fem el dispatch de l'acció login amb les dades rebudes del servei
                //data.ok
                if(data.dia !=undefined)
                {
                    let { dia,incidencies } = data;
                    dispatch(FixatgeDiaConsultat(data));
                }else
                {
                    //El servei d'aunteticació reporta un error de login
                    
                }  
            }
            //element.innerHTML = data.id;
        })
        .catch(error => {
           // element.parentElement.innerHTML = `Error: ${error}`;
            dispatch(crearErrorAction("Excepció no controlada -  " + JSON.stringify(error)));
            console.error('There was an error!', error);
        });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
       
        /*setTimeout(() => {
                //Als 3 segons, farem un dispatch del l'acció Login. 
                
                dispatch(login(123,345,"German, usuari autenticat"));

            }, 3500);*/
    }


} 


 
export const addFixatgeAsync = (tipusFixatge,token,idioma='ca',saltaPortalComb = '1') =>{
 
    return (dispatch) =>{
        //dispatch(uiIniciarCarregaAction());      
        
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
        var dadesFormulari = {
            'tipusFixatge': tipusFixatge
        };
        //Preparem els parametres post per enviar
        var formBody = [];
            for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
        
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8','Accept':'application/json','Authorization' : token },
                credentials: 'include',
                body: formBody
            };
            //TODO - Crear un fitxer on guardem constants segons l'entorn 
        return fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/fixatge/add',requestOptions)
            .then(async response => {
              
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
               
                //Anem a recuperar els fixatges, després de fer la crida al servei add
                dispatch(recuperarDetallSetmanaActual(token));
        
                // check for error response
                if (!response.ok) {

                    // get error message from body or default to response status
                    //const error = (data && data.message) || response.status;
                    //dispatch(crearErrorAction("Error del servei d'autenticació: " +  JSON.stringify(data)));
                }else
                {
                    //Fem el dispatch de l'acció login amb les dades rebudes del servei
                    if(data.ok)
                    {
                        //window.location.href = "https://oficinavirtual2.comb.cat/spog/virtualoffice/bookmark";
                        // if(tipusFixatge == 1 || tipusFixatge == 2 ){
                        //     if(saltaPortalComb ==1 ){
                        //         //Fem que trigui 3 segons, per veure el missatge de que tot OK
                        //         setTimeout(function() { window.open('https://www.portalcomb.cat/', '_blank'); }, 2000);

                                
                        //     }
                        // }
                        if(idioma =="ca"){
                            dispatch(crearTotOkAction(data.msg));
                        }else if(idioma =="es"){
                            dispatch(crearTotOkAction(data.msg_es));
                        }
                        
                        
                        //let { token } = data;
                        //let { idT,idE,nom,cognom,sexe  } = data.contingut;
                        //dispatch(login(token,idT,idE,nom,cognom,sexe));
                    }else
                    {
                        if(idioma =="ca"){
                            dispatch(crearErrorTotOkAction(data.msg));
                        }else if(idioma=="es"){
                            dispatch(crearErrorTotOkAction(data.msg_es));
                        }
                        //El servei d'aunteticació reporta un error de login
                        //dispatch(crearErrorAction(data.msg));
                    }  
                }

                //dispatch(uiFinalitzarCarregaAction());
                //element.innerHTML = data.id;
            })
            .catch(error => {
                
               // element.parentElement.innerHTML = `Error: ${error}`;
                //dispatch(crearErrorAction("Excepció no controlada -  " + JSON.stringify(error)));
                console.error('There was an error!', error);
                //dispatch(uiFinalitzarCarregaAction());
            });
      
        /*setTimeout(() => {
                //Als 3 segons, farem un dispatch del l'acció Login. 
                
                dispatch(login(123,345,"German, usuari autenticat"));

            }, 3500);*/
    }


}



export const JornadaComplerta = (tipusFixatge,token,idioma='ca',saltaPortalComb = '1') =>{
    //Aquesta funció (Middleware), retorna un callback. Just quan finalitza la petició, execitarà l'acció 
    return (dispatch) =>{   
        var dadesFormulari = {
            'tipusFixatge': tipusFixatge
        };
        var formBody = [];
            for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8','Accept':'application/json','Authorization' : token },
                credentials: 'include',
                body: formBody
            };
            
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/fixatge/complet',requestOptions)

        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();

            //Anem a recuperar els fixatges, després de fer la crida al servei add
            dispatch(recuperarDetallSetmanaActual(token));
            dispatch(uiAmagarJornadaCompletaAction())  
           
            if (response.status != 200) {
                // get error message from body or default to response status
                //const error = (data && data.message) || response.status;
                dispatch(crearErrorAction("Error del servei d'autenticació: " +  JSON.stringify(data)));
            }else
            {     
                if(data.ok)
                    {
                        dispatch(uiAmagarJornadaCompletaAction())  
                        //window.location.href = "https://oficinavirtual2.comb.cat/spog/virtualoffice/bookmark";
                        // if(tipusFixatge == 1 || tipusFixatge == 2 ){
                        //     if(saltaPortalComb ==1 ){
                        //         //Fem que trigui 3 segons, per veure el missatge de que tot OK
                        //         setTimeout(function() { window.open('https://www.portalcomb.cat/', '_blank'); }, 2000);     
                        //     }
                        // }
                        if(idioma =="ca"){
                            dispatch(crearTotOkAction(data.msg));
                        }else if(idioma =="es"){
                            dispatch(crearTotOkAction(data.msg_es));
                        }
                        
                        
                        //let { token } = data;
                        //let { idT,idE,nom,cognom,sexe  } = data.contingut;
                        //dispatch(login(token,idT,idE,nom,cognom,sexe));
                    }else
                    {
                        if(idioma =="ca"){
                            dispatch(crearErrorTotOkAction(data.msg));
                        }else if(idioma=="es"){
                            dispatch(crearErrorTotOkAction(data.msg_es));
                        }
                        //El servei d'aunteticació reporta un error de login
                        //dispatch(crearErrorAction(data.msg));
                    }   
            }
            //element.innerHTML = data.id;
        })
        .catch(error => {
           // element.parentElement.innerHTML = `Error: ${error}`;
            dispatch(crearErrorAction("Excepció no controlada -  " + JSON.stringify(error)));
            console.error('There was an error!', error);
        });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
       
        /*setTimeout(() => {
                //Als 3 segons, farem un dispatch del l'acció Login. 
                
                dispatch(login(123,345,"German, usuari autenticat"));

            }, 3500);*/
    }


} 

//Quan finalitza la crida del servei correctament, marquem l'estat cpConsultarFixatgeJornada
export const ConsultaFixatgeJornada = (llistatFixatges) =>{
    return {
        type: types.cpConsultarFixatgeJornada,
        llistatFixatges
    }

}

export const IncidenciaDiaConsultat = (incidenciaDiaConsultat) =>{
    return {
        type: types.cpDiaIncidenciaConsultat,
        incidenciaDiaConsultat
    }

}
export const FixatgeDiaConsultat = (fixatgeDiaConsultat) =>{
    return {
        type: types.cpDiaFixatgeConsultat,
        fixatgeDiaConsultat
    }

}
export const ResetFixatgeDiaConsulta = () =>{
    return {
        type: types.cpDiaFixatgeConsultat,
        payload: false
    }

}
export const ResetIncidenciaDiaConsultat = () =>{
    return {
        type: types.cpDiaIncidenciaConsultat,
        payload: false
    }

}

export const ConsultaIncidenciaJornada = (llistatIncidencies) =>{
    return {
        type: types.cpConsultarIncidenciaJornada,
        llistatIncidencies
    }

}

export const JornadaIniciada = (iniciada) =>{
    return {
        type: types.cpJornadaIniciada,
        iniciada
    }

}

export const JornadaFinalitzada = (finalitzada) =>{
    return {
        type: types.cpJornadaFinalitzada,
        finalitzada
    }

}

export const JornadaIncidencia = (incidencia) =>{
    return {
        type: types.cpJornadaIncidencia,
        incidencia
    }

}

export const ConsultarFixatgesSetmanaActualFinalitzat = (finalitzat,llistatFixatgesSetmana) =>{
    return {
        type: types.cpConsultarFixatgeSetmanaActual,
        finalitzat,
        llistatFixatgesSetmana
    }
    
}
export const ConsultarIncidenciesSetmanaActual = (finalitzat,llistatIncidenciesSetmana) =>{
    return {
        type: types.cpConsultarIncidenciesSetmanaActual,
        finalitzat,
        llistatIncidenciesSetmana
    }
    
}

// ─── NOU: Detall setmana actual (1 crida) ────────────────────────────────────
export const recuperarDetallSetmanaActual = (token) => {
    return (dispatch) => {
        dispatch({ type: types.cpLoadingDetallSetmana, payload: true });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/setmana/actual/detall', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                if (response.ok && data.ok) {
                    dispatch({ type: types.cpDetallSetmanaComplet, payload: data.contingut });
                }
                dispatch({ type: types.cpLoadingDetallSetmana, payload: false });
            })
            .catch(error => {
                console.error('recuperarDetallSetmanaActual error:', error);
                dispatch({ type: types.cpLoadingDetallSetmana, payload: false });
            });
    };
};

// ─── NOU: Detall dia concret post-guardat ────────────────────────────────────
export const recuperarDetallDiaComplet = (token, data) => {
    return (dispatch) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': token },
            body: JSON.stringify({ dataConsulta: data })
        };
        fetch(process.env.REACT_APP_DOMINI_API_PORTALCOMB + '/dia/detall', requestOptions)
            .then(async response => {
                const json = await response.json();
                if (response.status === 200 && json.ok) {
                    dispatch({ type: types.cpActualitzarDiaDetallSetmana, payload: json.contingut });
                }
            })
            .catch(error => console.error('recuperarDetallDiaComplet error:', error));
    };
};